exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:768px){.hero-container-images[data-v-6c388997]{width:100%}}.border-radius-10[data-v-6c388997]{border-radius:10px}.p-0[data-v-6c388997]{padding:0}.justify-content-between[data-v-6c388997]{-webkit-box-pack:justify!important;-ms-flex-pack:justify!important;justify-content:space-between!important}.mr-3[data-v-6c388997]{margin-right:3rem}.max-w-images-banner[data-v-6c388997]{max-width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c388997","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/app/components/HeroBoxSponsor.vue
// module id = eV9M
// module chunks = 1